import { render, staticRenderFns } from "./PoliciesTab.vue?vue&type=template&id=ef7b2c56&scoped=true"
import script from "./PoliciesTab.vue?vue&type=script&lang=js"
export * from "./PoliciesTab.vue?vue&type=script&lang=js"
import style0 from "./PoliciesTab.vue?vue&type=style&index=0&id=ef7b2c56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7b2c56",
  null
  
)

export default component.exports